const IconNewWindow = (): JSX.Element => {
  return (
    <>
      <path
        d="M17.9,23.6h-13c-2.2,0-3.9-1.7-3.9-3.9v-13c0-2.2,1.7-3.9,3.9-3.9h5.2c0.8,0,1.3,0.5,1.3,1.3s-0.5,1.3-1.3,1.3
	H4.9C4.1,5.4,3.6,6,3.6,6.7v13c0,0.8,0.5,1.3,1.3,1.3h13c0.8,0,1.3-0.5,1.3-1.3v-5.2c0-0.8,0.5-1.3,1.3-1.3s1.3,0.5,1.3,1.3v5.2
	C21.8,21.9,20.1,23.6,17.9,23.6L17.9,23.6z M10.1,15.8c-0.4,0-0.6-0.1-0.9-0.4c-0.5-0.5-0.5-1.3,0-1.8L20,2.8h-4.7
	c-0.8,0-1.3-0.5-1.3-1.3s0.5-1.3,1.3-1.3h7.8l0,0l0,0c0.1,0,0.4,0,0.5,0.1c0.1,0,0.3,0.1,0.4,0.3s0.3,0.3,0.3,0.4s0.1,0.3,0.1,0.5
	l0,0l0,0v7.8c0,0.8-0.5,1.3-1.3,1.3c-0.8,0-1.3-0.5-1.3-1.3V4.7L11,15.4C10.8,15.7,10.5,15.8,10.1,15.8L10.1,15.8z"
      />
    </>
  );
};

export default IconNewWindow;
